import { paginatedTransform } from 'src/services/skuit/utils'
import { Event, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Events {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Event>> => {
    const response = await this.api.get('/tracking/events', config)
    return paginatedTransform(Event)(response.data)
  }
}
